import React from "react";
import { InputAdornment } from "@material-ui/core";
import { Values } from "@src/Tools/Values";
import SearchIcon from "@material-ui/icons/Search";
import { STTextField } from "./styles";

interface IProps {
  onChange: (event: any) => void;
  value: string;
}

export default class TableSearchInput extends React.Component<IProps> {
  render() {
    return (
      <>
        <STTextField
          label={Values.getLocalizationValue("filter")}
          onChange={this.props.onChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          value={this.props.value}
        />
      </>
    );
  }
}
